import React from 'react';
import { bool, string, array, object } from 'prop-types';
import { themr } from 'react-css-themr';

import Latex from '@blueberry/components/Latex';

import styles from './QuestionBlock.scss';
const cx = require('classnames/bind').bind(styles);

function QuestionBlock({ hasLatex, description, images, theme }) {
  const hasImage = images.length > 0;

  const renderImage = (src, index) => {
    return <img src={src} key={index} />;
  };

  return (
    <div className={cx(theme.root, hasImage && theme.hasImage)}>
      {hasLatex ? <Latex content={description} /> : <div>{description}</div>}
      {hasImage && (
        <div className={theme.imageWrapper}>{images.map(renderImage)}</div>
      )}
    </div>
  );
}

QuestionBlock.propTypes = {
  hasLatex: bool.isRequired,
  theme: object.isRequired,
  description: string,
  images: array,
};

QuestionBlock.defaultProps = {
  description: '',
  images: [],
};

export default themr('DefaultQuestionBlockTheme', styles)(QuestionBlock);



// WEBPACK FOOTER //
// ./app/components/QuestionBlock/QuestionBlock.jsx